// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogManager } from "@lib/logging/LogManager";
import { RawMessage } from "@lib/messaging/RawMessage";
import { RawMessageSerializer } from "@lib/messaging/RawMessageSerializer";
import { SingleSocketEndpoint } from "@lib/messaging/SingleSocketEndpoint";
import { Socket } from "@lib/messaging/Socket";
import { EventSocket } from "@lib/messaging/sockets/EventSocket";
import { EventListener } from "@lib/utilities/EventListener";
import { IEventListener } from "@lib/utilities/IEventListener";

const log = LogManager.createLog("EventSocketEndpoint");

export class EventSocketEndpoint implements SingleSocketEndpoint
{
  readonly socketType = "single";
  private readonly _onMessage = new EventListener<(endpoint: SingleSocketEndpoint, socket: Socket, rawMessage: RawMessage) => void>();
  private readonly rawMessageSerializer = new RawMessageSerializer();
  readonly socket: EventSocket;

  constructor(eventTarget: EventTarget, receiveEventName: string, sendEventName: string)
  {
    const socket = new EventSocket(eventTarget, receiveEventName, sendEventName);
    socket.onMessage.addListener((message) => this.handleMessage(socket, message));
    this.socket = socket;
  }

  get onMessage(): IEventListener<(endpoint: SingleSocketEndpoint, socket: Socket, rawMessage: RawMessage) => void>
  {
    return this._onMessage;
  }

  sendRawMessage(rawMessage: RawMessage): void
  {
    const message = this.rawMessageSerializer.serialize(rawMessage);
    this.socket.sendMessage(message);
  }

  private handleMessage(socket: Socket, message: object)
  {
    const rawMessage = this.rawMessageSerializer.deserialize(message);
    if (!rawMessage)
    {
      log.error("Dropped received raw message: invalid format (%o)", message);
      return;
    }

    this._onMessage.dispatch(this, socket, rawMessage);
  }
}